"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BsMediaCardContent = exports.BsMediaCardLink = exports.BsMediaCardWrapper = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_basis_bs_link_1 = require("@hotelplan/core.basis.bs-link");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
exports.BsMediaCardWrapper = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    position: 'relative',
    justifyContent: 'center',
    textAlign: 'center',
    height: '100%',
    width: '100%',
    borderRadius: 'default',
    overflow: 'hidden',
    ':before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundImage: 'linear-gradient(-180deg, rgba(0, 0, 0, 0) 45%, rgba(0, 0, 0, 0.6) 100%)',
    },
    img: {
        width: '100%',
        height: '100%',
        objectFit: `cover`,
    },
}));
exports.BsMediaCardLink = exports.BsMediaCardWrapper.withComponent(core_basis_bs_link_1.BsLink);
exports.BsMediaCardContent = styled_components_1.default.div.attrs(({ title, subTitle, children }) => ({
    children: (react_1.default.createElement(react_1.default.Fragment, null,
        title && (react_1.default.createElement("div", { className: "card-text" },
            react_1.default.createElement("h3", { className: "card-title" }, title))),
        subTitle && react_1.default.createElement("p", { className: "card-subtitle" }, subTitle),
        children)),
    title: undefined,
    subTitle: undefined,
}))((0, util_theme_sxc_1.sx2CssThemeFn)({
    px: 4,
    pb: ['30px', 4],
    color: 'white',
    position: 'absolute',
    bottom: 0,
    width: '100%',
    textAlign: 'center',
    '.card-title': {
        fontSize: [3, '30px'],
    },
    '.card-subtitle': {
        fontSize: [2, 3],
    },
    '.wishlist-icon': {
        position: 'absolute',
        right: '16px',
        top: '16px',
        width: '26px',
        height: '26px',
        color: 'white',
        cursor: 'pointer',
    },
    '.button-text': {
        display: 'none',
    },
}));
//# sourceMappingURL=bs-media-card.styles.js.map